module.exports = __webpack_public_path__ + "img/Weapon_44.99415c49.png";